import React, { useState } from "react";
import { CgMenu, CgClose } from "react-icons/cg";
import { NavLink, useLocation } from "react-router-dom"; // Importe useLocation
import "./navbutton.css";

const Navbutton = () => {
  const [menuIcon, setMenuIcon] = useState(false);
  const location = useLocation(); // Para verificar a rota atual

  // Função para rolar até uma seção específica
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };

  // Função para navegar para a página principal e rolar até a seção
  const navigateToSection = (sectionId) => {
    if (location.pathname !== "/") {
      // Se não estiver na página principal, redirecione para "/"
      window.location.href = `/#${sectionId}`;
    } else {
      // Se já estiver na página principal, role até a seção
      scrollToSection(sectionId);
    }
    setMenuIcon(false); // Fechar o menu após o clique
  };

  return (
    <div>
      <div className={menuIcon ? "nav-sidebar-2 active" : "nav-sidebar-2"}>
        <nav className="side-nav-2">
          {/* Link para a página inicial */}
          <NavLink
            to="/"
            className="side-nav-links-2"
            style={{ textDecoration: "none", color: "#16a085" }}
            onClick={() => {
              setMenuIcon(false);
              scrollToSection("home"); // Rolar até a seção "home"
            }}
          >
            <p>Início</p>
          </NavLink>
          
          
            <a
              href="#about"
              className="side-nav-links-2"
              style={{ textDecoration: "none", color: "#16a085" }}
              onClick={(e) => {
                e.preventDefault();
                navigateToSection("about");
              }}
            >
              <p>Sobre</p>
            </a><div className="side-nav-div-2">
            {/* Links para as seções */}
            <a
              href="#services"
              className="side-nav-links-2"
              style={{ textDecoration: "none", color: "#16a085" }}
              onClick={(e) => {
                e.preventDefault(); // Evitar o comportamento padrão do link
                navigateToSection("services"); // Navegar para a seção "services"
              }}
            >
              <p>Serviços</p>
            </a>
            <a
              href="#doctors"
              className="side-nav-links-2 side-nav-list-2"
              style={{ textDecoration: "none", color: "#16a085" }}
              onClick={(e) => {
                e.preventDefault();
                navigateToSection("doctors");
              }}
            >
              <p>Equipe</p>
            </a>
            <a
              href="#reviews"
              className="side-nav-links-2 side-nav-list-2"
              style={{ textDecoration: "none", color: "#16a085" }}
              onClick={(e) => {
                e.preventDefault();
                navigateToSection("reviews");
              }}
            >
              <p>Clientes</p>
            </a>
            <a
              href="#blogs"
              className="side-nav-links-2 side-nav-list-2"
              style={{ textDecoration: "none", color: "#16a085" }}
              onClick={(e) => {
                e.preventDefault();
                navigateToSection("blogs");
              }}
            >
              <p>Blog</p>
            </a>
            <a
              href="#contact"
              className="side-nav-links-2 side-nav-list-2"
              style={{ textDecoration: "none", color: "#16a085" }}
              onClick={(e) => {
                e.preventDefault();
                navigateToSection("contact");
              }}
            >
              <p>Contato</p>
            </a>

            {/* Ícone de fechar */}
            <CgClose
              style={{ textDecoration: "none", color: "#16a085" }}
              className="mobile-nav-icon close-outline"
              onClick={() => setMenuIcon(false)}
            />
          </div>
        </nav>
      </div>
      {/* Botão para abrir o menu */}
      <div className="mobile-navbar-btn">
        <CgMenu
          style={{ textDecoration: "none", color: "#16a085" }}
          className="mobile-nav-icon"
          onClick={() => setMenuIcon(true)}
        />
      </div>
    </div>
  );
};

export default Navbutton;